import { ReactElement, ReactNode } from 'react';
import * as S from './Container.styles';

export const Container = ({
    children,
    isWidget,
}: {
    children: ReactNode;
    isWidget?: boolean;
}): ReactElement => {
    if (isWidget) {
        return <>{children}</>;
    }

    return <S.Container>{children}</S.Container>;
};
